// Third Party
import moment from "moment";

// Components
import { BasicCard } from "@Layouts/components/Cards/BasicCard";

// Types
import { IReviewResponse } from "@DataPages/types/socialMediaReviews/model";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

type ReviewResponsesProps = Readonly<{
	responses: IReviewResponse[];
}>;

function sortResponsesByDate(date1: Date | string, date2: Date | string) {
	return new Date(date1).getTime() - new Date(date2).getTime();
}

export default function ReviewResponses(props: ReviewResponsesProps) {
	return props.responses
		.sort((revResponse1, revResponse2) => sortResponsesByDate(revResponse2.createdAt, revResponse1.createdAt))
		.map((response: IReviewResponse) => {
			return (
				<BasicCard
					key={`${new Date(response.createdAt).toISOString()}-${response.siteAuthorName}`}
					title={"Response from store"}
					subtitle={moment(response.createdAt).format(DATE_FORMAT.fullAbbrTime12h)}
					leftBorder
					borderColor={"#CCCCCC"}
					borderWidth={1}
					sx={{ borderRadius: 0, mt: 2, px: 2, pt: 1, pb: 0 }}
				>
					{response?.body}
				</BasicCard>
			);
		});
}
